import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { RouterModule} from'@angular/router';

// Components
import { FooterComponent } from './components/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { PendientesComponent } from './components/pendientes/pendientes.component';
import { CrearPendienteComponent } from './components/crear-pendiente/crear-pendiente.component';
import { DetallePendienteComponent } from './components/detalle-pendiente/detalle-pendiente.component';
import { ControlPagosComponent } from './components/control-pagos/control-pagos.component'
import { BuscadorComponent } from './components/buscador/buscador.component';
import { CambioDeUnidadComponent } from './components/cambio-unidad/cambio-unidad.component'
import { UnidadesDisponiblesComponent } from './components/unidades-disponibles/unidades-disponibles.component';
import { CrearEventoComponent } from './components/crear-evento-linea-de-tiempo/crear-evento.components';
import { LineaTiempoComponent } from './components/linea-tiempo-viajes/linea-tiempo-viajes.component'

//Componentes Separados De Pagos
import { ListaPagoComponent} from './components/lista-pagos/lista-pagos.component';
import { ProgramarPagoComponent } from './components/programar-pago/programar-pago.component';
import { RegistrarPagoComponent } from './components/registrar-pago/registrar-pago.component'
import {  viajeTerminadoComponent } from './components/viajes-terminados/viaje-terminado.component'
// Pipes
import { RolDeUsuarioPipe } from './pipes/roles-personal.pipe';
import { IdiomasPipe } from './pipes/idiomas.pipe';
import { PuestosPipe } from './pipes/puestos.pipe';
import { NotasPendientePipe } from './pipes/notas-pendientes.pipe';
import { FiltrarPagosPipe } from './pipes/filtrar-pagos.pipe';
import { FiltrarViajesPorAprobacion } from './pipes/filtrar-viajes-por-aprobacion.pipe';
import { FiltrarCargasDeGasolinaPorOperadorPipe } from './pipes/filtrar-cargas-de-gasolina-por-operador.pipe';
import { FiltrarCargasDeGasolinaPipePorUnidad } from './pipes/filtrar-cargas-de-gasolina-por-unidad.pipe';
import { GenerarResumenDeCargasDeGasolinaPipe } from './pipes/generar-resumen-de-cargas-de-gasolina.pipe';
import { ObtenerPropiedadDeUnidadPipe } from './pipes/obtener-propiedad-de-unidad.pipe';
import { PropiedadClientePipe } from './pipes/propiedad-cliente.pipe';
import { PropiedadContactoPipe } from './pipes/propiedad-contacto.pipe';
import { PropiedadUsuarioPipe } from './pipes/propiedad-usuario.pipe';
import { PropiedadPasajeroPipe } from './pipes/propiedad-pasajero.pipe';
import { PasajerosViajePipe } from './pipes/obtener-pasajeros-viaje.pipe';
import { IntervaloTiempoServicioPipe } from './pipes/intervalo-tiempo-servicio.pipe';
import { GenerarObjetoServiciosCotizacionPipe } from './pipes/generar-objeto-servicios-cotizacion.pipe';
import { GenerarObjetoCombinacionesPipe } from './pipes/generar-objeto-combinaciones.pipe';
import { GenerarObjetoConceptosAdicionalesPipe } from './pipes/generar-objeto-conceptos-adicionales.pipe';
import { SumarCostoPipe } from './pipes/sumar-costos.pipe';
import { BuscadorPipe } from './pipes/buscador.pipe';
import { Ng2Accordion } from 'ng2-native-accordion';
import { ItinerarioConfirmacionesPipe } from './pipes/arreglo-confirmaciones.pipe';
import { VerificarAprobacionPipe} from'./pipes/verificar-aprobacion.pipe';
import { FiltrarContactosPipe} from './pipes/filtro-contactos.pipe';
import { FiltrarServiciosPorHora } from './pipes/filtrar-servicios-por-hora.pipe';
import { arregloDePuntosIntermedios } from './pipes/arreglo-puntos-intermedios.pipe';
import { GenearArregloDeViajes } from './pipes/generar-arreglo-de-viajes.pipe';
import { OrdenarPorNombrePipe } from './pipes/ordenar-por-nombre.pipe';
import { OrdenarPorFechaDeCreacionPipe } from './pipes/ordenar-por-fecha-creacion.pipe';
import { BuscadorPersonalPipe } from './pipes/busquedor-personal.pipe'
import { ObtenerPropiedadInicioDeServicioPipe } from './pipes/obtener-inicio-servicio.pipe';
import { ObtenerPropiedadDeServicio } from './pipes/obtener-propiedad-servicio.pipe';
import { ObtenerPropiedadConfirmacion } from './pipes/obtener-propiedad-confirmacion.pipe';
import { ObtenerPropiedadDeConfrimacionesServicio } from './pipes/propiedad-confirmaciones-servicios.pipe';
import { FiltrarUnidadesPipe } from './pipes/filtrar-unidades.pipe';
import { FiltrarConfirmaciones } from './pipes/filtrar-confirmaciones-por-TipoVenta.pipe';
import { ObtenerDireccionPipe } from "./pipes/obtener-direccion-por-coordenadas.pipe";
import { SumarPagosPipe } from "./pipes/sumar-pagos.pipe"
import { DisponibilidadComponent } from './components/disponibilidad/disponibilidad.component';
import { NotificacionesComponent } from './components/notificaciones/notificaciones.component';
import { FormasDePagoComponent } from './components/formas-de-pago/formas-de-pago.component';
import { AlertaZonaRojaComponent } from './components/alerta-zona-roja/alerta-zona-roja.component';
@NgModule({
    imports:[
        FormsModule,
        CommonModule,
        RouterModule
    ],
    declarations: [
        HeaderComponent,
        FooterComponent,
        PendientesComponent,
        NotificacionesComponent,
        DisponibilidadComponent,
        CrearPendienteComponent,
        DetallePendienteComponent,
        ControlPagosComponent,
        BuscadorComponent,
        UnidadesDisponiblesComponent,
        RolDeUsuarioPipe,
        IdiomasPipe,
        PuestosPipe,
        NotasPendientePipe,
        PropiedadClientePipe,
        PropiedadContactoPipe,
        FiltrarPagosPipe,
        FiltrarViajesPorAprobacion,
        FiltrarCargasDeGasolinaPorOperadorPipe,
        FiltrarCargasDeGasolinaPipePorUnidad,
        GenerarResumenDeCargasDeGasolinaPipe,
        ObtenerPropiedadDeUnidadPipe,
        PropiedadClientePipe,
        PropiedadUsuarioPipe,
        PropiedadPasajeroPipe,
        PasajerosViajePipe,
        IntervaloTiempoServicioPipe,
        GenerarObjetoServiciosCotizacionPipe,
        GenerarObjetoCombinacionesPipe,
        GenerarObjetoConceptosAdicionalesPipe,
        SumarCostoPipe,
        BuscadorPipe,
        ItinerarioConfirmacionesPipe,
        VerificarAprobacionPipe,
        FiltrarContactosPipe,
        FiltrarServiciosPorHora,
        arregloDePuntosIntermedios,
        GenearArregloDeViajes,
        OrdenarPorNombrePipe,
        OrdenarPorFechaDeCreacionPipe,
        BuscadorPersonalPipe,
        CambioDeUnidadComponent,
        ObtenerPropiedadInicioDeServicioPipe,
        ObtenerPropiedadDeServicio,
        ObtenerPropiedadConfirmacion,
        ObtenerPropiedadDeConfrimacionesServicio,
        CrearEventoComponent,
        LineaTiempoComponent,
        FiltrarUnidadesPipe,
        ListaPagoComponent,
        ProgramarPagoComponent,
        RegistrarPagoComponent,
        viajeTerminadoComponent,
        FiltrarConfirmaciones,
        ObtenerDireccionPipe,
        SumarPagosPipe,
        FormasDePagoComponent,
        AlertaZonaRojaComponent
    ],
    exports : [
        HeaderComponent,
        FooterComponent,
        DisponibilidadComponent,
        PendientesComponent,
        NotificacionesComponent,
        CrearPendienteComponent,
        DetallePendienteComponent,
        ControlPagosComponent,
        BuscadorComponent,
        RolDeUsuarioPipe,
        IdiomasPipe,
        PuestosPipe,
        NotasPendientePipe,
        PropiedadClientePipe,
        PropiedadContactoPipe,
        FiltrarPagosPipe,
        FiltrarViajesPorAprobacion,
        FiltrarCargasDeGasolinaPorOperadorPipe,
        FiltrarCargasDeGasolinaPipePorUnidad,
        GenerarResumenDeCargasDeGasolinaPipe,
        ObtenerPropiedadDeUnidadPipe,
        PropiedadClientePipe,
        PropiedadUsuarioPipe,
        PropiedadPasajeroPipe,
        PasajerosViajePipe,
        IntervaloTiempoServicioPipe,
        GenerarObjetoServiciosCotizacionPipe,
        GenerarObjetoCombinacionesPipe,
        GenerarObjetoConceptosAdicionalesPipe,
        SumarCostoPipe,
        BuscadorPipe,
        Ng2Accordion,
        ItinerarioConfirmacionesPipe,
        VerificarAprobacionPipe,
        FiltrarContactosPipe,
        FiltrarServiciosPorHora,
        arregloDePuntosIntermedios,
        GenearArregloDeViajes,
        OrdenarPorNombrePipe,
        OrdenarPorFechaDeCreacionPipe,
        BuscadorPersonalPipe,
        CambioDeUnidadComponent,
        ObtenerPropiedadInicioDeServicioPipe,
        UnidadesDisponiblesComponent,
        ObtenerPropiedadDeServicio,
        ObtenerPropiedadConfirmacion,
        ObtenerPropiedadDeConfrimacionesServicio,
        CrearEventoComponent,
        LineaTiempoComponent,
        FiltrarUnidadesPipe,
        ListaPagoComponent,
        ProgramarPagoComponent,
        RegistrarPagoComponent,
        viajeTerminadoComponent,
        FiltrarConfirmaciones,
        ObtenerDireccionPipe,
        SumarPagosPipe,
        FormasDePagoComponent,
        AlertaZonaRojaComponent
    ]
})

export class SharedModule{}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/shared.module.ts